/** @format */

import React from "react";

const css = require("./Degree.module.css");

export default function EducationImg() {
  return (
    <svg
      role="presentation"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="50vw"
      height="40vw"
      viewBox="0 0 795.39431 574.03802"
      className={css.degreeImage}
    >
      <defs>
        <linearGradient
          x1="-450.78971"
          y1="2803.04671"
          x2="-450.78971"
          y2="2729.34772"
          gradientTransform="translate(3217.53309 1009.65784) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor="gray"
            stopOpacity="0.25"
          />
          <stop
            offset="0.53514"
            stopColor="gray"
            stopOpacity="0.12"
          />
          <stop
            offset="1"
            stopColor="gray"
            stopOpacity="0.1"
          />
        </linearGradient>
      </defs>
      <title></title>
      {/* Sroll End */}
      <ellipse
        cx="232.05775"
        cy="450.06897"
        rx="35.09476"
        ry="5.26421"
        transform="translate(-476.55674 294.92367) rotate(-63.61079)"
        fill="var(--text-primary)"
      />
      {/* Scroll End */}
      <ellipse
        cx="670.57742"
        cy="667.85592"
        rx="35.09476"
        ry="3.57677"
        transform="translate(-428.03695 808.73554) rotate(-63.61079)"
        fill="var(--text-primary)"
      />
      <rect
        x="397.95325"
        y="566.93514"
        width="21.05685"
        height="70.18951"
        transform="translate(274.52069 -285.26226) rotate(39.54732)"
        fill="#f55f44"
      />
      <rect
        x="409.32507"
        y="573.56618"
        width="23.69234"
        height="70.18951"
        transform="translate(489.54965 1134.58125) rotate(-166.7689)"
        opacity="0.05"
      />
      <rect
        x="411.92558"
        y="573.86778"
        width="21.05685"
        height="70.18951"
        transform="translate(492.0121 1135.47005) rotate(-166.7689)"
        fill="#f55f44"
      />
      <rect
        x="414.48638"
        y="314.08219"
        width="73.69899"
        height="489.57186"
        transform="translate(-452.20218 551.7936) rotate(-63.61079)"
        fill="url(#b2a81085-935f-40be-bb27-75940df8c338)"
      />
      {/* Scroll Body */}
      <path
        d="M655.01556,699.105c-8.584-4.11751-444.8438-220.718-438.55625-217.5983,24.21371-36.95739,31.19689-62.87545,31.19689-62.87545l438.55625,217.5983S670.81132,663.25857,655.01556,699.105Z"
        transform="translate(-0202.30284 -162.98099)"
        fill="var(--card-background2)"
      />
      <rect
        x="421.72508"
        y="519.09383"
        width="40.35897"
        height="70.18951"
        transform="translate(90.06389 -301.64381) rotate(26.38921)"
        opacity="0.05"
      />
      <rect
        x="423.47981"
        y="519.09383"
        width="36.8495"
        height="70.18951"
        transform="translate(90.06389 -301.64381) rotate(26.38921)"
        fill="#f55f44"
      />
      <rect
        x="428.83545"
        y="518.70387"
        width="24.56633"
        height="70.18951"
        transform="translate(89.80867 -301.33512) rotate(26.38921)"
        opacity="0.05"
      />
      <rect
        x="430.59019"
        y="518.70387"
        width="21.05685"
        height="70.18951"
        transform="translate(89.80867 -301.33512) rotate(26.38921)"
        fill="#f55f44"
      />
      <circle
        cx="261.30557"
        cy="563.92499"
        r="2.92569"
        fill="#dbdbdb"
      />
      <g opacity="0.5">
        <rect
          x="29.39431"
          y="482"
          width="3"
          height="17"
          fill="#47e6b1"
        />
        <rect
          x="231.69716"
          y="644.98099"
          width="3"
          height="17"
          transform="translate(684.3753 257.30284) rotate(90)"
          fill="#47e6b1"
        />
      </g>
      <g opacity="0.5">
        <rect
          x="785.39431"
          y="270"
          width="3"
          height="17"
          fill="#47e6b1"
        />
        <rect
          x="987.69716"
          y="432.98099"
          width="3"
          height="17"
          transform="translate(1228.3753 -710.69716) rotate(90)"
          fill="#47e6b1"
        />
      </g>
      {/* Hat Inside circle */}
      <path
        d="M407.19716,520.481l-24,36s8,37,185,36,191-36,191-36l-33-48-101-69Z"
        transform="translate(-202.30284 -162.98099)"
        fill="var(--text-secondary)"
      />
      <path
        d="M407.19716,520.481l-24,36s8,37,185,36,191-36,191-36l-33-48-101-69Z"
        transform="translate(-202.30284 -162.98099)"
        opacity="0.15"
      />
      {/* Hat Top square */}
      <polygon
        points="715.394 224 400.394 363 16.394 224 368.394 64 541.184 143.67 547.374 146.53 715.394 224"
        fill="var(--text-secondary)"
      />
      <polygon
        points="715.394 224 400.394 363 16.394 224 368.394 64 541.184 143.67 547.374 146.53 715.394 224"
        opacity="0.15"
      />
      {/* Tassel String */}
      <polygon
        points="553.894 257.32 547.894 257.68 541.184 143.67 547.374 146.53 553.894 257.32"
        fill="var(--text-negative)"
      />
      {/* Middle of Hat */}
      <path
        d="M411.19716,386.481l-28,170s201-65,376,0l-26-180S498.19716,347.481,411.19716,386.481Z"
        transform="translate(-202.30284 -162.98099)"
        fill="var(--card-background)"
      />
      <ellipse
        cx="553.39431"
        cy="272"
        rx="29"
        ry="20"
        fill="var(--card-background2)"
      />
    </svg>
  );
}
